import { createAction } from 'redux-actions'
import { DivisionId } from '../../../services/api.types'

const ns = 'my-groups/'

export const getGroupMembers = createAction<{ divisionId: DivisionId }>(`${ns}GET_GROUP_MEMBERS`)
export const getGroupMembersSuccess = createAction<any>(`${ns}GET_GROUP_MEMBERS_SUCCESS`)
export const getGroupMembersFail = createAction<any>(`${ns}GET_GROUP_MEMBERS_FAIL`)
